//mata angin brand colors
export const green = "#00B29D";
export const red = "#CA0E68";
export const purple = "#8E43F4";
export const blue = "#3B72FF";
export const orange = "#FFA800";
export const grey = "#959494";
export const darkGrey = "#808080";
export const oldGrey = "#6A6868";
export const white = "#ffffff";
